import { Box, Flex, Text } from '@/components';
import { DIFF_DEFAULT_FONT_SIZE } from '@/utils';
import type { CSSProperties, FC, PropsWithChildren } from 'react';

type Props = {
  legend?: string;
  width?: number;
  childrenJustify?: CSSProperties['justifyContent'];
};

export const LegendNode: FC<PropsWithChildren<Props>> = ({
  children,
  legend,
  width = 200,
  childrenJustify,
}) => {
  return (
    <Flex gap={6}>
      {legend && (
        <Box width={width}>
          <Text
            style={{ fontSize: DIFF_DEFAULT_FONT_SIZE }}
            weight="regular"
            color="secondary"
            text={legend}
          />
        </Box>
      )}
      <Flex flex={1} justify={childrenJustify}>
        {children}
      </Flex>
    </Flex>
  );
};
